import { Icon } from '@fnacdarty/back-office-ui';
import styled from 'styled-components';

// eslint-disable-next-line import/prefer-default-export
export const StyledFilterContainer = styled.div`
	/* position: absolute;
	top: 20px;
	left: 20px;
	z-index: 100; */
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	position: relative;
	margin: 0px 0px 0px 20px;
	background-color: ${({ theme }) => theme.colors.primaryLight};
	color: #ffffff;
	border: 1px solid transparent;
	border-radius: 5px;
	padding: 10px;
	height: 520px;
	width: 20%;
	padding-top: 20px;
`;

export const StyledHeader = styled.div`
	margin-bottom: 20px;
	display: flex;
	flex-direction: column;
	width: 100%;
	justify-content: center;
	align-items: flex-start;
	& > hr {
		border: 1px solid #ffffff;
	}
`;

export const StyledInputSearchContainer = styled.div`
	display: flex;
	width: 100%;
	position: relative;
	& > input {
		margin-bottom: 0 !important;
	}
`;

export const StyledSearchIcon = styled(Icon)`
	position: absolute;
	top: 50%;
	right: 10px;
	transform: translateY(-50%);
	color: ${({ theme }) => theme.colors.text};
`;

export const StyledDropdownContainer = styled.div`
	display: flex;
	width: 100%;
	margin-bottom: 10px;
`;
